import { render, staticRenderFns } from "./VVideoUpload.vue?vue&type=template&id=ceb7a64a&scoped=true"
import script from "./VVideoUpload.vue?vue&type=script&lang=ts"
export * from "./VVideoUpload.vue?vue&type=script&lang=ts"
import style0 from "./VVideoUpload.vue?vue&type=style&index=0&id=ceb7a64a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceb7a64a",
  null
  
)

export default component.exports